import TimelineItem from "./TimelineItem";
import type { TimelineEvent } from "./types";

type Props = {
    data: TimelineEvent[];
    onItemClick: (item: TimelineEvent) => void;
};

export default function TimelineFeatures({ data, onItemClick }: Props) {
    return (
        <div className="space-y-0">
            {data.map((event, index) => (
                <TimelineItem
                    key={event.id}
                    event={event}
                    index={index}
                    onItemClick={onItemClick}
                />
            ))}
        </div>
    );
}